import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ShimmerLoader from "../../../pages/ShimmerLoader/ShimmerLoader";
import { clearOfflineGoldPurchase, fetchOfflineGoldTransactionReport } from "../../../../store/actions/report/ReportsAction";
import NoDataFound from "../../common/NoDataFound";
import Styles from "./StorePurchaseReport.module.css";
import moment from "moment-timezone";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { convertToISTDate, convertToISTDateTime } from "../../../../utils/DateTime.service";
import currenyFormat from "../../common/currentFormat";

const StorePurchaseReport = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState(moment().subtract(7, "days"));
  const [endDate, setEndDate] = useState(moment());
  const itemsPerPage = Number(process.env.REACT_APP_ITEMS_PER_PAGE);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const payload = {
      start_date: startDate ? startDate.format("YYYY-MM-DD") : "",
      end_date: endDate ? endDate.format("YYYY-MM-DD") : "",
    };
    dispatch(fetchOfflineGoldTransactionReport(payload, navigate));
  }, [dispatch, navigate]);

  const { offlineGoldPurchase, loading } = useSelector((state) => state.reports);

  const totalPages = Math.ceil(offlineGoldPurchase.length / itemsPerPage);

  const defaultOptions = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    theme: "colored",
  };

  const handleGo = () => {
    // const payload = {
    //   start_date: startDate.format("YYYY-MM-DD"),
    //   end_date: endDate.format("YYYY-MM-DD"),
    // };
    // dispatch(fetchOfflineGoldTransactionReport(payload, navigate));
    if (!startDate || !endDate) {
      toast.error("Please select both start and end dates.", defaultOptions);
      return;
    }

    const payload = {
      start_date: startDate.format("YYYY-MM-DD"),
      end_date: endDate.format("YYYY-MM-DD"),
    };
    dispatch(fetchOfflineGoldTransactionReport(payload, navigate));
  };

  const onFormReset = () => {
    // const newStartDate = moment().subtract(7, "days");
    // const newEndDate = moment();
    // setStartDate(newStartDate);
    // setEndDate(newEndDate);
    // setCurrentPage(1);
    // const payload = {
    //   start_date: newStartDate.format("YYYY-MM-DD"),
    //   end_date: newEndDate.format("YYYY-MM-DD"),
    // };
    // dispatch(clearOfflineGoldPurchase());
    setStartDate(null);
    setEndDate(null);
    setCurrentPage(1);

    dispatch(clearOfflineGoldPurchase());
  };

  const onPageChange = (increment) => {
    setCurrentPage((prevPage) => Math.max(1, Math.min(prevPage + increment, totalPages)));
  };

  const handleDownload = () => {
    if (offlineGoldPurchase.length === 0) {
      toast.info("No data available for download!", defaultOptions);
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(
      offlineGoldPurchase.map((item) => ({
        ID: `${item.id}` || "--",
        TransactionID: `${item.trans_id}` || "--",
        TransactionType: `${item.trans_type}` || "--",
        TransactionCategoryLinkID: `${item.trans_category_link_id}` || "--",
        CustomerName: `${item.party_name}` || "--",
        Address: `${item.address}` || "--",
        MobileNo: `${item.mobile_no}` || "--",
        PanNo: `${item.pan_no}` || "--",
        GstNo: `${item.gst_no}` || "--",
        DocumentNo: `${item.doc_no}` || "--",
        TransactionDate: `${convertToISTDate(item.trans_date)}` || "--",
        EntryDate: `${convertToISTDate(item.entry_date)}` || "--",
        GrossWeight: `${item.gross_wt} gm` || "--",
        NetWeight: `${item.net_wt} gm` || "--",
        MetalRate: `₹ ${item.metal_rate}` || "--",
        MetalAmount: `₹ ${item.metal_amt}` || "--",
        AmountBeforeTax: `₹ ${item.amt_before_tax}` || "--",
        GstAmount: `${item.gst_amt}` || "--",
        AmountAfterTax: `₹ ${item.amt_after_tax}` || "--",
        CreatedAt: `${convertToISTDateTime(item.created_at)}` || "--",
        MakingCost: `₹ ${item.making_cost}` || "--",
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Offline Gold Purchase");

    XLSX.writeFile(workbook, `Store Purchase_${moment().format("YYYY-MM-DD")}.xlsx`);
  };

  const currentItems = offlineGoldPurchase.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <div className='row page-titles'>
        <ol className='breadcrumb'>
          <li className='breadcrumb-item active'>
            <Link to={"#"}>Reports</Link>
          </li>
        </ol>
      </div>
      <div className='row'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-header d-flex justify-content-between align-items-center'>
              <h4 className='card-title mb-0'>Store Purchase Report</h4>
              <div className='d-flex align-items-center justify-content-end'>
                <div className='d-flex flex-column mx-1 w-25'>
                  <div className='ms-2'>From:</div>
                  <DatePicker selected={startDate ? startDate.toDate() : null} onChange={(date) => setStartDate(moment(date))} dateFormat='dd-MM-yyyy' className='form-control mx-1' maxDate={endDate ? endDate.toDate() : null} onKeyDown={(e) => e.preventDefault()} />
                </div>
                <div className='d-flex flex-column mx-1 w-25'>
                  <div className='ms-2'>To:</div>
                  <DatePicker selected={endDate ? endDate.toDate() : null} onChange={(date) => setEndDate(moment(date))} dateFormat='dd-MM-yyyy' className='form-control mx-1' minDate={startDate ? startDate.toDate() : null} maxDate={moment().toDate()} onKeyDown={(e) => e.preventDefault()} />
                </div>
                <div className='d-flex mt-3'>
                  <button className='btn btn-primary mx-1' type='button' onClick={handleGo}>
                    Go
                  </button>
                  <button className='btn btn-outline-secondary mx-1' type='button' onClick={onFormReset}>
                    Clear
                  </button>
                  <button className='btn btn-outline-secondary mx-1' type='button' onClick={handleDownload}>
                    Download
                  </button>
                </div>
              </div>
            </div>
            <div className='card-body'>
              <div className='table-responsive ticket-table'>
                <div id='ticket_wrapper' className='dataTables_wrapper no-footer'>
                  <div className='table-responsive'>
                    <table className='display dataTablesCard table-responsive-xl dataTable no-footer w-100'>
                      <thead>
                        <tr>
                          <th>Transaction ID</th>
                          <th>Transaction Date</th>
                          <th>Phone</th>
                          <th className='text-center'>Transaction Type</th>
                          <th>Customer Name</th>
                          <th>Making Cost</th>
                          <th>Metal Rate</th>
                          <th>Net Weight</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={8} className='text-center'>
                              <ShimmerLoader width='95%' height='20%' count={3} />
                            </td>
                          </tr>
                        ) : currentItems.length > 0 ? (
                          currentItems.map((item, index) => (
                            <tr key={index}>
                              {/* <td>
                                <Link className={`${Styles.link}`} to={`/transactions-details/${item.trans_id}`}>{item.trans_id || "--"}</Link>
                              </td> */}
                              <td>{item.trans_id || "--"}</td>
                              <td>{item.trans_date ? convertToISTDateTime(item.trans_date) : "--"}</td>
                              <td>{item.mobile_no || "--"}</td>
                              <td className='text-center'>{item.trans_type || "--"}</td>
                              <td>{item.party_name || "--"}</td>
                              <td>{item.making_cost ? currenyFormat(item.making_cost) : "--"}</td>
                              <td>{item.metal_rate ? currenyFormat(item.metal_rate) : "--"}</td>
                              <td>{`${item.net_wt} gm` || "--"}</td>
                            </tr>
                          ))
                        ) : (
                          <tr className={`${Styles.no_hover}`}>
                            <td className={`fs-3 text-center`} colSpan={8}>
                              <NoDataFound width={450} />
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {offlineGoldPurchase.length > 0 && (
                    <div className='d-flex justify-content-end align-items-center px-4 py-2'>
                      <div className='dataTables_paginate paging_simple_numbers mb-0 d-flex align-items-center'>
                        <i className={`fa fa-chevron-circle-left fa-2x ${currentPage === 1 ? "text-muted" : "text-primary"}`} onClick={() => onPageChange(-1)} style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}></i>
                        <span className='mx-2'>
                          Page {currentPage} of {totalPages}
                        </span>
                        <i className={`fa fa-chevron-circle-right fa-2x ${currentPage === totalPages || totalPages === 0 ? "text-muted" : "text-primary"}`} onClick={() => onPageChange(1)} style={{ cursor: currentPage === totalPages || totalPages === 0 ? "not-allowed" : "pointer" }}></i>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  // return (
  //   <>
  //     <div className='row page-titles'>
  //       <ol className='breadcrumb'>
  //         <li className='breadcrumb-item active'>
  //           <Link to={"#"}>Reports</Link>
  //         </li>
  //       </ol>
  //     </div>
  //     {loading && <ShimmerLoader width='95%' height='20%' count={4} />}
  //     {!loading && (
  //       <div className='row'>
  //         <div className='col-lg-12'>
  //           <div className='card'>
  //             <div className='card-header d-flex justify-content-between align-items-center'>
  //               <h4 className='card-title mb-0'>Store Purchase Report</h4>
  //               <div className='d-flex align-items-center justify-content-end'>
  //                 <div className='d-flex flex-column  mx-1 w-25'>
  //                   <div className='ms-2'>From:</div>

  //                   <DatePicker selected={startDate ? startDate.toDate() : null} onChange={(date) => setStartDate(moment(date))} dateFormat='dd-MM-yyyy' className='form-control mx-1' maxDate={endDate ? endDate.toDate() : null} />
  //                 </div>
  //                 <div className='d-flex flex-column mx-1 w-25'>
  //                   <div className='ms-2'>To:</div>
  //                   <DatePicker selected={endDate ? endDate.toDate() : null} onChange={(date) => setEndDate(moment(date))} dateFormat='dd-MM-yyyy' className='form-control mx-1' minDate={startDate ? startDate.toDate() : null} maxDate={moment().toDate()} />
  //                 </div>
  //                 <div className="'d-flex mt-3">
  //                   <button className='btn btn-primary mx-1' type='button' onClick={handleGo}>
  //                     Go
  //                   </button>
  //                   <button className='btn btn-outline-secondary mx-1' type='button' onClick={onFormReset}>
  //                     Clear
  //                   </button>
  //                   <button className='btn btn-outline-secondary mx-1' type='button' onClick={handleDownload}>
  //                     Download
  //                   </button>
  //                 </div>
  //               </div>
  //             </div>
  //             <div className='card-body'>
  //               <div className='table-responsive ticket-table'>
  //                 <div id='ticket_wrapper' className='dataTables_wrapper no-footer'>
  //                   <div className='table-responsive'>
  //                     <table className='display dataTablesCard table-responsive-xl dataTable no-footer w-100'>
  //                       <thead>
  //                         <tr>
  //                           <th>Transaction ID</th>
  //                           <th>Transaction Date</th>
  //                           <th>Phone</th>
  //                           <th>Transaction Type</th>
  //                           <th>Customer Name</th>
  //                           <th>Making Cost</th>
  //                           <th>Metal Rate</th>
  //                           <th>Net Weight</th>
  //                         </tr>
  //                       </thead>
  //                       <tbody>
  //                         {currentItems.length > 0 ? (
  //                           currentItems.map((item, index) => (
  //                             <tr key={index}>
  //                               <td>{item.trans_id || "--"}</td>
  //                               <td>{item.trans_date ? convertToISTDate(item.trans_date) : "--"}</td>
  //                               <td>{item.mobile_no || "--"}</td>
  //                               <td>{item.trans_type || "--"}</td>
  //                               <td>{item.party_name || "--"}</td>
  //                               <td>₹ {item.making_cost || "--"}</td>
  //                               <td>₹ {item.metal_rate || "--"}</td>
  //                               <td>{`${item.net_wt} gm` || "--"}</td>
  //                             </tr>
  //                           ))
  //                         ) : (
  //                           <tr className={`${Styles.no_hover}`}>
  //                             <td className={`fs-3 text-center`} colSpan={7}>
  //                               <NoDataFound width={450} />
  //                             </td>
  //                           </tr>
  //                         )}
  //                       </tbody>
  //                     </table>
  //                   </div>
  //                   {offlineGoldPurchase.length > 0 && (
  //                     <div className='d-flex justify-content-end align-items-center px-4 py-2'>
  //                       <div className='dataTables_paginate paging_simple_numbers mb-0 d-flex align-items-center'>
  //                         <i className={`fa fa-chevron-circle-left fa-2x ${currentPage === 1 ? "text-muted" : "text-primary"}`} onClick={() => onPageChange(-1)} style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}></i>
  //                         <span className='mx-2'>
  //                           Page {currentPage} of {totalPages}
  //                         </span>
  //                         <i className={`fa fa-chevron-circle-right fa-2x ${currentPage === totalPages || totalPages === 0 ? "text-muted" : "text-primary"}`} onClick={() => onPageChange(1)} style={{ cursor: currentPage === totalPages || totalPages === 0 ? "not-allowed" : "pointer" }}></i>
  //                       </div>
  //                     </div>
  //                   )}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     )}
  //   </>
  // );
};

export default StorePurchaseReport;
